import {
  UPDATE_VOUCHER_NO,
  UPDATE_NARRATION,
  UPDATE_PIN_CODE,
  UPDATE_CITY,
  UPDATE_STATE,
  ACCOUNTS_NAME,
  DRAWER_OPEN_ADD_ACCOUNTS,
  ON_FOCUS_CURRENT_INDEX,
  UPDATE_COUNTRY
} from './types';

const updateVoucherNo = payload => {
  return {
    type: UPDATE_VOUCHER_NO,
    payload: payload
  };
};

// const onUpdateBranchInput = payload => {

// };

const updateNarration = payload => {
  return {
    type: UPDATE_NARRATION,
    payload: payload
  };
};

const updatePincode = payload => {
  return {
    type: UPDATE_PIN_CODE,
    payload: payload
  };
};

const updateCity = payload => {
  return {
    type: UPDATE_CITY,
    payload: payload
  };
};

const updateState = payload => {
  return {
    type: UPDATE_STATE,
    payload: payload
  };
};

const updateCountry = payload => {
  return {
    type: UPDATE_COUNTRY,
    payload: payload
  };
};
// const addOtherChargesAfterTax = () => {
//   return {
//     type: ADD_LINE
//   };
// };

const storeAccountsName = payload => {
  return {
    type: ACCOUNTS_NAME,
    payload: payload
  };
};

const drawerOpenAddAccounts = () => {
  return {
    type: DRAWER_OPEN_ADD_ACCOUNTS
  };
};

const onFocus = payload => {
  return {
    type: ON_FOCUS_CURRENT_INDEX,
    payload: payload
  };
};

export {
  updateVoucherNo,
  updateNarration,
  updatePincode,
  updateCity,
  updateState,
  // addOtherChargesAfterTax,
  storeAccountsName,
  drawerOpenAddAccounts,
  onFocus,
  updateCountry
};
